import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { AcceptanceExtended } from './acceptance.models';

/**
 * Acceptance Firestore data-access service.
 * Extends {@link FirestoreBase} to reuse generic CRUD and query helpers.
 * Use inherited methods such as `get$`, `getOneWhere$`, `create`, `upsert`, and `update`
 * from higher layers (`acceptance.service`) unless an acceptance-specific query is required.
 */
@Injectable({ providedIn: 'root' })
export class AcceptanceDbService extends FirestoreBase<AcceptanceExtended> {

  constructor(firestore: Firestore) {
    super(
      'acceptances',
      firestore
    );
  }
}
